module.exports = __webpack_public_path__ + "static/img/assistant@2x.e6a97b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/assistant@2x.png
// module id = 2O10
// module chunks = 44